import React, {FC, useEffect, useState, useContext} from 'react';
import {
    IDataGap,
    ComponentTypeID
} from "../types/types";
import {get, post} from "../fetchers/fetchers";
import {  useTask, TasksDispatchContext } from '../stateManagement/context';
import { get_query } from '../stateManagement/data';
 
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton, Tab, Table, TableBody, TableCell, TableHead, TableRow, Typography
} from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import DialogContentText from "@material-ui/core/DialogContentText";
import {useParams} from "react-router";
import {Delete, Edit} from "@material-ui/icons";
import AddDataGapDialog from "./add_datagap_dialog";

import { getDataGaps } from '../stateManagement/data';
import { API_URL } from "../env";
import InvestigationsCell from './investigationscell';
interface DataGapProps {
    assessment_template_group_id: number,
    template_id?:number

}

interface IRouteParams {
    id: string
}



const DataGaps: FC<DataGapProps> = ({assessment_template_group_id , template_id}) => {

    const [openCreateDialog, setOpenCreateDialog] = useState<boolean>(false);
    const [areYouSure, setAreYouSure] = useState<boolean>(false);
    const [openEditDialog, setOpenEditDialog] = useState<boolean>(false);


    const params = useParams<IRouteParams>()

    const [dataGaps, setDataGaps] = useState<IDataGap[]>([])
    const [currentDataGap, setCurrentDataGap] = useState<IDataGap>();

    const [isLoaded, setIsLoaded] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    
    let dispatch = useContext(TasksDispatchContext)

    let tasks = useTask()

    const [write_access, setWriteAccess] = useState<boolean>(false);

    useEffect(() => {
        setWriteAccess(tasks.write_access)
    },[tasks])

    useEffect(() => {
        if(tasks.loaded){

            let filtered_assessment = tasks.dataGaps.filter(datagap => datagap.assessment_template_group_id === assessment_template_group_id)
            if (template_id) {
                filtered_assessment = filtered_assessment.filter(datagap => datagap.assessment_template_id === template_id)
            }
            setDataGaps(filtered_assessment)

        }
    }, [tasks.loaded, tasks.dataGaps, assessment_template_group_id, template_id])

    const handleDelete = () => {
        setAreYouSure(false)
        if (!currentDataGap)
            return
        let ra = {...currentDataGap}
        ra.is_active = false
        updateDataGap(ra)
    }



    const handleClose = () => {
        setOpenCreateDialog(false)
    }


    const handleCloseEdit = () => {
        setOpenEditDialog(false)
    }

    const handleOpen = () => {
        setOpenCreateDialog(true)
    }

    const updateDataGap = (i: IDataGap) => {
        delete i.id
        delete i.group
        if (template_id) {
            i.assessment_template_id = template_id
        }
        postDataGap(i).then( ()=> {
            setIsLoaded(false)
        })
    }
    const postDataGap= async (f: IDataGap) => {
        // check if states in params
        let query_params = get_query()

        // check if state key in params
        if (query_params.state) {
            f["state_id"] = parseInt(query_params.state)
        }
        await post<IDataGap>( API_URL + "summary_assessment/" +  params.id +"/data_gap" , f);
        getDataGaps( params.id, dispatch)

    }

    const handleAreaYouSure = () => {
        setAreYouSure(false)
    }

    const renderAreYouSure = () => {
        return(
            <Dialog open={areYouSure} onClose={handleAreaYouSure} aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title">Remove  {currentDataGap?.name}</DialogTitle>

                <DialogContent>
                    <DialogContentText>
                        <Typography>
                            Are you sure you want to remove investigation <b>{currentDataGap?.name}</b>
                        </Typography>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleAreaYouSure} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={handleDelete} color="primary">
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }

    const renderDataGap = (index: number, dataGap: IDataGap) => {
        return (
            <TableRow>
                <TableCell>{dataGap.name}</TableCell>
                <TableCell><InvestigationsCell elementUUID={dataGap.uuid} linkType={ComponentTypeID.SummaryOfKnowledge} writeAccess={write_access} /></TableCell>

                <TableCell>

                    { write_access && <><IconButton color="primary" aria-label="upload picture" component="span" style={{
                        color:"rgb(239,88,43)",

                    }} onClick={() => {
                        setCurrentDataGap(dataGap)
                        setOpenEditDialog(true)
                    }}>
                        <Edit />
                    </IconButton>

                    <IconButton color="primary" aria-label="upload picture" component="span"  style={{
                        color:"rgb(239,88,43)",

                    }} onClick={() => {
                        setCurrentDataGap(dataGap)
                        setAreYouSure(true)

                    }} >
                        <Delete />
                    </IconButton> 
                    </>
                    }
                </TableCell>

            </TableRow>
        )
    }

    return (
        <>
            { renderAreYouSure()}

            {openCreateDialog && <AddDataGapDialog datagap={{
                assessment_template_group_id, uuid:-1, is_active: true
            }} updateDataGap={updateDataGap} closeDialogCallback={handleClose}/>}

            { (openEditDialog && currentDataGap) && <AddDataGapDialog datagap={currentDataGap} updateDataGap={updateDataGap} closeDialogCallback={handleCloseEdit}/>}


            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>Data Gap</TableCell>
                        <TableCell>Investigations</TableCell>
                        <TableCell></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    <TableRow>
                        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={5} align={"center"}>
                            {write_access &&
                            <IconButton color="primary" component="span"
                                        style={{
                                            margin: "auto",
                                            backgroundColor:"rgb(239,88,43)",
                                            color:"rgb(255,255,255)"
                                        }} onClick={() => handleOpen()}>
                                <AddIcon fontSize="small"/>
                            </IconButton>
                            }
                        </TableCell>
                        
                    </TableRow>

                    {dataGaps.map((f, index) => {
                        return renderDataGap(index, f)
                    })}

                </TableBody>
            </Table>
        </>
    );
}

export default DataGaps;

